import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/global.css'
import { applyHrFlagFromUrlOnce } from './utils/hr'

// 在应用渲染前同步解析URL参数，确保isHrEnabled()能立即获取正确值
applyHrFlagFromUrlOnce()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
